/**
 * Canonical list of widget types the dashboard recognises.
 * Widget configs, the widget component registry, and settings-overrides all
 * derive their valid `type` values from here.
 */
export const WIDGET_TYPES = {
  AccessDiscovery: 'access-discovery',
  FilesCovered: 'files-covered',
  HumanIdentities: 'human-identities',
  NonHumanIdentities: 'non-human-identities',
  Sensitivity: 'sensitivity',
  StaleDuplicateData: 'stale-duplicate-data',
  TopDataAccessed: 'top-data-accessed',
  TopIdentities: 'top-identities',
} as const;

export type WidgetType = (typeof WIDGET_TYPES)[keyof typeof WIDGET_TYPES];
